import type { jiraSingleSelectFragment as JiraSingleSelectField } from '@atlassian/jira-business-fields/src/common/field-types/single-select/fragment/__generated_apollo__/jiraSingleSelectFragment.ts';
import { SELECT_CF_TYPE } from '@atlassian/jira-platform-field-config';
import type { DataTransformFn } from '../../../bulk-edit-transform/types';
import type { SingleSelectFormData } from './types';

export const transformSingleFieldForOptimisticUpdates: DataTransformFn<
	JiraSingleSelectField,
	SingleSelectFormData | null
> = (
	existingField: JiraSingleSelectField,
	fieldData: SingleSelectFormData | null,
): JiraSingleSelectField => {
	if (fieldData === null) {
		return {
			...existingField,
			fieldOption: null,
		};
	}
	return {
		...existingField,
		fieldOption: {
			__typename: 'JiraOption',
			optionId: fieldData.value,
			value: fieldData.label,
			color: null,
		},
	};
};

export const singleSelectOptimisticUpdatesHandler: {
	[key: string]: DataTransformFn<JiraSingleSelectField, SingleSelectFormData>;
} = {
	[SELECT_CF_TYPE]: transformSingleFieldForOptimisticUpdates,
};
